module.exports = __webpack_public_path__ + "img/positive-result.b174651a.svg";